<!-- circle-control.component.html -->
<div id="control-panel">
  <svg width="200" height="110">
    <circle cx="100" cy="60" r="40" stroke="black" stroke-width="3" fill="transparent"></circle>
    <circle [attr.cx]="handlePosition.x" [attr.cy]="handlePosition.y" r="10" stroke="black" stroke-width="2" fill="yellow" (mousedown)="onMouseDown($event)"></circle>
  </svg>
</div>